import { Injectable } from '@angular/core';
import { StateToken, State, Action, StateContext, Selector } from '@ngxs/store';
import { TimePeriod } from 'src/app/shared/dashboard/models/time-period.enum';
import { SetDashboardModalOpen, SetDeviationsOverTimeFilters } from './dashboard-plugins.actions';

export interface DeviationsOverTimeFilters {
  vesselIds: string[];
  deviationTypeIds: string[];
  timePeriod: TimePeriod;
  customDateRange?: {
    from: Date;
    to: Date;
  };
}

export interface DashboardPluginsStateModel {
  deviationsOverTime: DeviationsOverTimeFilters;
  isDashboardModalOpen: boolean;
}

const DASHBOARD_PLUGINS_STATE_TOKEN = new StateToken<DashboardPluginsStateModel>(
  'dashboardPlugins'
);

@State<DashboardPluginsStateModel>({
  name: DASHBOARD_PLUGINS_STATE_TOKEN,
  defaults: {
    deviationsOverTime: {
      vesselIds: [],
      deviationTypeIds: [],
      timePeriod: TimePeriod.Last12Months,
    },
    isDashboardModalOpen: false,
  },
})
@Injectable()
export class DashboardPluginsState {
  @Action(SetDeviationsOverTimeFilters)
  setDeviationsOverTimeFilters(
    { getState, setState }: StateContext<DashboardPluginsStateModel>,
    { filters }: SetDeviationsOverTimeFilters
  ) {
    const state = getState();
    setState({
      ...state,
      deviationsOverTime: {
        ...state.deviationsOverTime,
        ...filters,
      },
    });
  }

  @Action(SetDashboardModalOpen)
  setDashboardModalOpen(
    { patchState }: StateContext<DashboardPluginsStateModel>,
    { isOpen }: SetDashboardModalOpen
  ) {
    patchState({ isDashboardModalOpen: isOpen });
  }

  @Selector()
  static deviationsOverTimeFilters(state: DashboardPluginsStateModel): DeviationsOverTimeFilters {
    return state.deviationsOverTime;
  }

  @Selector()
  static isDashboardModalOpen(state: DashboardPluginsStateModel): boolean {
    return state.isDashboardModalOpen;
  }
}
